module.exports = __webpack_public_path__ + "fonts/Minecrafter.53a42fcb.ttf";